export const redirectTo = (url) => {
    const fallbackUrl = '/';
    try {
        const candidate = typeof url === 'string' ? url.trim() : '';
        const resolvedUrl = new URL(candidate, window.location.origin);
        const isSameOrigin = resolvedUrl.origin === window.location.origin;
        const isHttpProtocol = resolvedUrl.protocol === 'http:' || resolvedUrl.protocol === 'https:';

        if (!candidate || !isSameOrigin || !isHttpProtocol) {
            window.history.replaceState(null, null, fallbackUrl);
            window.location.href = fallbackUrl;
            return;
        }

        const safeTarget = resolvedUrl.pathname + resolvedUrl.search + resolvedUrl.hash;
        window.history.replaceState(null, null, safeTarget);
        window.location.href = safeTarget;
    } catch (e) {
        window.history.replaceState(null, null, fallbackUrl);
        window.location.href = fallbackUrl;
    }
}
